export default "__VITE_ASSET__241ca188__"